<template>
  <div class="privacy-policy-page">
    <!-- Navbar Area -->
    <div class="navbar-area" :class="{ 'is-sticky': isSticky }">
      <div class="template-responsive-navbar">
          <div class="container">
              <div class="template-responsive-menubar">
                  <div class="logo">
                      <router-link to="/">
                        <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                      </router-link>
                  </div>
                  <div class="meanmenu-reveal" id="meanmenu-reveal" @click="toggleMobileMenu"><span></span></div>
              </div>
          </div>
          <!-- Mobile Menu -->
          <div class="mean-nav" :class="{ 'mean-show': isMobileMenuOpen }">
              <div class="mobile-menu-container">
                  <ul class="navbar-nav">
                    <li class="nav-item"><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'services')">{{ t.services }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'services' }">
                        <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                        <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                      </ul>
                    </li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'blog')">{{ t.blog }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'blog' }">
                        <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                      </ul>
                    </li>
                    
                    <!-- Language Switcher -->
                    <li class="nav-item">
                      <a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'language')">
                        {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }} <i class="bx bx-plus dropdown-icon"></i>
                      </a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'language' }">
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')" style="padding: 10px 0 10px 20px;">English</button></li>
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')" style="padding: 10px 0 10px 20px;">中文</button></li>
                      </ul>
                    </li>
                  </ul>
                  
                  <div class="others-option d-flex flex-column mt-4">
                    <div class="item mb-3">
                      <a href="/login" class="default-btn">{{ t.signIn }}</a>
                    </div>
                    
                    <div class="item">
                      <a href="/register" class="default-btn">{{ t.signUp }}</a>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="template-navbar">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <router-link class="navbar-brand" to="/">
              <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
            </router-link>

            <button class="navbar-toggler" type="button" @click="isNavCollapsed = !isNavCollapsed" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mean-menu" :class="{ 'show': !isNavCollapsed }">
              <ul class="navbar-nav">
                <li class="nav-item"><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.services }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                    
                    <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                  </ul>
                </li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.blog }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                
                <!-- Language Switcher -->
                <li class="nav-item">
                  <a href="#" class="dropdown-toggle nav-link">
                    {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')">English</button></li>
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')">简体中文</button></li>
                  </ul>
                </li>
              </ul>

              <div class="others-option d-flex align-items-center">
                <div class="item">
                  <a href="/login" class="default-btn">{{ t.signIn }}</a>
                </div>

                <div class="item">
                  <a href="/register" class="default-btn">{{ t.signUp }}</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.privacyPolicyTitle }}</h1>
          <p>{{ t.privacyPolicySubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Privacy Policy Content Section -->
    <section class="policy-content-section ptb-100 bg-light">
      <div class="container">
        <div class="policy-content">
          <div class="policy-header">
            <h2>{{ languageState.currentLanguage === 'en' ? privacyData.title1 : privacyDataZh.title1 }}</h2>
            <div class="policy-meta">
              <span>{{ languageState.currentLanguage === 'en' ? privacyData.title2 : privacyDataZh.title2 }}</span>
              <span>{{ languageState.currentLanguage === 'en' ? privacyData.title3 : privacyDataZh.title3 }}</span>
            </div>
          </div>
          
          <div class="policy-body">
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title55 : privacyDataZh.title55 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title4 : privacyDataZh.title4 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title5 : privacyDataZh.title5 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title6 : privacyDataZh.title6 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title7 : privacyDataZh.title7 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title8 : privacyDataZh.title8 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title9 : privacyDataZh.title9 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title10 : privacyDataZh.title10 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title11 : privacyDataZh.title11 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title12 : privacyDataZh.title12 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title13 : privacyDataZh.title13 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title14 : privacyDataZh.title14 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title15 : privacyDataZh.title15 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title16 : privacyDataZh.title16 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title17 : privacyDataZh.title17 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title18 : privacyDataZh.title18 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title19 : privacyDataZh.title19 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title20 : privacyDataZh.title20 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title21 : privacyDataZh.title21 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title22 : privacyDataZh.title22 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title23 : privacyDataZh.title23 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title24 : privacyDataZh.title24 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title25 : privacyDataZh.title25 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title26 : privacyDataZh.title26 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title27 : privacyDataZh.title27 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title28 : privacyDataZh.title28 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title29 : privacyDataZh.title29 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title30 : privacyDataZh.title30 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title31 : privacyDataZh.title31 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title32 : privacyDataZh.title32 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title33 : privacyDataZh.title33 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title34 : privacyDataZh.title34 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title35 : privacyDataZh.title35 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title36 : privacyDataZh.title36 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title37 : privacyDataZh.title37 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title38 : privacyDataZh.title38 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title39 : privacyDataZh.title39 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title40 : privacyDataZh.title40 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title41 : privacyDataZh.title41 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title42 : privacyDataZh.title42 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title43 : privacyDataZh.title43 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title44 : privacyDataZh.title44 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title45 : privacyDataZh.title45 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title46 : privacyDataZh.title46 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title47 : privacyDataZh.title47 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title48 : privacyDataZh.title48 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title49 : privacyDataZh.title49 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title50 : privacyDataZh.title50 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title51 : privacyDataZh.title51 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title52 : privacyDataZh.title52 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title53 : privacyDataZh.title53 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? privacyData.title54 : privacyDataZh.title54 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title56 : privacyDataZh.title56 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title57 : privacyDataZh.title57 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title58 : privacyDataZh.title58 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title59 : privacyDataZh.title59 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title60 : privacyDataZh.title60 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title61 : privacyDataZh.title61 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title62 : privacyDataZh.title62 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title63 : privacyDataZh.title63 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title64 : privacyDataZh.title64 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title65 : privacyDataZh.title65 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title66 : privacyDataZh.title66 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title67 : privacyDataZh.title67 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title68 : privacyDataZh.title68 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title69 : privacyDataZh.title69 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title70 : privacyDataZh.title70 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title71 : privacyDataZh.title71 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title72 : privacyDataZh.title72 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title73 : privacyDataZh.title73 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title74 : privacyDataZh.title74 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title75 : privacyDataZh.title75 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title76 : privacyDataZh.title76 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title77 : privacyDataZh.title77 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title78 : privacyDataZh.title78 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title79 : privacyDataZh.title79 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title80 : privacyDataZh.title80 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title81 : privacyDataZh.title81 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title82 : privacyDataZh.title82 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title83 : privacyDataZh.title83 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title84 : privacyDataZh.title84 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title85 : privacyDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title86 : privacyDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title87 : privacyDataZh.title87 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title88 : privacyDataZh.title88 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title89 : privacyDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title90 : privacyDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title91 : privacyDataZh.title91 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title92 : privacyDataZh.title92 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title93 : privacyDataZh.title93 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? privacyData.title94 : privacyDataZh.title94 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? privacyData.title95 : privacyDataZh.title95 }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Privacy Policy Content Section -->

    <!-- Footer Section -->
    <footer class="footer-section pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.contactInfo }}</h3>
                        <ul class="footer-contact-info">
                            <!-- <li>Fish St Hill, Bridge, London EC3R 8AH, UK</li> -->
                            <li><a href="javascript:void(0);">super@proxylink.net</a></li>
                            <!-- <li><a href="tel:++254 25413 521">+254 25413 521</a></li>
                            <li><a href="tel:+254 25413 521">+254 25413 521</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget pl-4">
                        <h3>{{ t.usefulLinks }}</h3>
                        <ul class="links-list">
                            <!-- <li><a href="#">About Us</a></li> -->
                            <!-- <li><a href="#">Features</a></li> -->
                            <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                            <!-- <li><a href="#">Blog</a></li> -->
                            <!-- <li><a href="#">Contact</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.support }}</h3>
                        <ul class="links-list">
                            <li><router-link to="/privacy">{{ t.privacyPolicy }}</router-link></li>
                            <li><router-link to="/service-policy">{{ t.servicePolicy }}</router-link></li>
                            <!-- <li><a href="#">24/7 Support</a></li> -->
                            <!-- <li><a href="#">Contact Us</a></li> -->
                            <!-- <li><a href="#">About Us</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <a href="/" class="logo d-inline-block">
                            <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                        </a>
                        <p>{{ t.welcomeText }}</p>
                        <ul class="social-links">
                            <li><a href="javascript:void(0);"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="container">
                <p>{{ t.copyright }}</p>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->

    <div class="go-top" :class="{ 'active': showGoTop }" @click="scrollToTop"><i class='bx bx-up-arrow-alt'></i></div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      showGoTop: false,
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: null,
      privacyData: {
        title1: 'proxylink privacy agreement',
        title2: 'The latest update time of the agreement: July 15, 2023',
        title3: 'Agreement effective date: July 15, 2023',
        title55: 'Special Note',
        title4: 'Thank you for choosing and using proxylink service.',
        title5: 'For the purpose of facilitating your registration, login and use of proxylink related services, we may collect, save, use and share your information. proxylink attaches great importance to the protection of your information, and we will take corresponding security protection measures in accordance with legal and regulatory requirements. We will use this "proxylink Privacy Agreement" (hereinafter referred to as "this Agreement") to explain and describe to you how we collect, use, store and share your information when you use the products and services provided by proxylink, and how we Methods provided for you to access, update, control and protect this information.',
        title6: 'Unless otherwise stated by proxylink or otherwise agreed with you, the terms in this Privacy Agreement have the same meanings as those used in the "proxylink User Service Agreement".',
        title7: 'Please read this agreement carefully. When you confirm your acceptance of this agreement by checking the box online or by using proxylink services, you will be deemed to have fully read, understood and agreed to be bound by this agreement. This agreement will take legal effect between you and proxylink. ',
        title8: '1. Scope of application of this agreement',
        title9: '1.1 This agreement only applies to the products and service functions (hereinafter referred to as the "services") provided by proxylink (hereinafter referred to as "we" or "proxylink")',
        title10: '1.2 This agreement also applies to services and functions upgraded and updated by proxylink based on product development, including but not limited to websites, interfaces, customized programs, and derivative products and services that emerge with technological development.',
        title11: '1.3 This agreement applies to all information and materials submitted when you register and use proxylink, as well as information collected by proxylink to provide you with services.',
        title12: '1.4 This agreement does not apply to products/services provided by other third parties. For example, you obtain and use products/services provided by third parties through the proxylink website. The above-mentioned service agreement, usage policy and the legal relationship established between you and the third party need to be confirmed. Other information needs to be determined separately by you and the service provider.',
        title13: '1.5 If a product/service we provide has a separate privacy policy (including special agreements in its corresponding various agreements), the privacy policy and special agreements of the product/service will take precedence and the privacy of the product/service If the policy is not stipulated or the stipulation is unclear and there is no special agreement, the content of this agreement shall prevail.',
        title14: '2. Information we collect',
        title15: '2.1 You know and agree that we will collect your information in the following ways:',
        title16: '2.1.1 When registering a proxylink account, you actively submit your mobile phone number information, real-name information, set and confirm your login password, etc.',
        title17: '2.1.2 In special circumstances, you entrust and authorize our employees or partners to upload and submit relevant information on your behalf, such as your corresponding information that you entrust our customer service staff to fill in and upload.',
        title18: '2.1.3 The information we actively collect when you use our services includes but is not limited to:',
        title19: '(1) Operation records, we will receive and record the operation records, log records and related information of your use of the proxylink service.',
        title20: '(2) Contract information, if you need offline delivery, etc., you should provide necessary information such as contact person, contact information, address, invoicing information, order, etc.',
        title21: '2.2 When you perform real-name authentication, you need to provide your name, ID card, mobile phone number, facial information and other information according to the prompts on the web page. Only after your account passes these certifications and verifications can you be qualified to use related products/services. Please confirm that you submit legal, true, and valid information.',
        title22: '2.3 If you register proxylink in the name of a company, you need to submit your company name, unified social credit code, scanned copy or photo of business license, bank account information (including opening bank, bank account number and Account holder), and screenshots of corporate transfers. We will verify your identity based on the information you submitted.',
        title23: '2.4 If you need to join the promotion plan or become a proxylink agent, you need to sign a separate relevant agreement. To perform the contract, you should provide necessary information such as contact person and contact information.',
        title24: '2.5 The contract and other material information you signed when you used our customer service or participated in events organized by us.',
        title25: '2.6 Other information, such as consultation communication records.',
        title26: 'As our business develops, the product functions and services we provide may be adjusted and changed. If the purpose of processing changes, we will explain it to you again and obtain your consent. We will keep the above information for at least 6 months. All operation records will be fully logged and will be permanently sealed after 6 months.',
        title27: '3. How we use the collected information',
        title28: 'In order to provide you with high-quality, convenient and safe services, we use the information collected for the following purposes. If we use your information beyond the following purposes, we will explain it to you again and obtain your consent.',
        title29: '3.1 Provide services to you.',
        title30: '3.2 To achieve the purpose stipulated in the "Information We Collect" in this Agreement.',
        title31: '3.3 Push product news, proxylink updates and other related business news and commercial advertisements to you. For example, Teng proxylink can use your mobile phone number, email and other contact information to push commercial advertisements to you through text messages, phone calls, emails and other methods to publicize and promote proxylink services.',
        title32: '3.4 Invite you to participate in surveys about our products and services.',
        title33: '3.5 Improve, optimize and improve proxylink online services.',
        title34: '3.6 Report to relevant departments in accordance with laws, regulations or regulatory requirements.',
        title35: '4. Information we share, transfer and publicly disclose',
        title36: 'We will only share, transfer, publicly disclose, and entrust the processing of your information within the legal, legitimate, and necessary scope with your explicit authorization/consent and in compliance with relevant laws and regulations.',
        title37: '4.1 Sharing',
        title38: 'In order to provide you with more complete and high-quality products/services, we may share your information with our third-party partners. At this time, we will sign a strict confidentiality agreement with our partners, requiring them to handle your personal information in accordance with our instructions, this privacy policy, and any other relevant confidentiality and security measures. Except as stipulated by laws and regulations and as otherwise agreed between proxylink and you, we will not share your information with any unrelated third party without your consent.',
        title39: 'If you refuse our partners to collect the personal information necessary to provide services when providing services, you may not be able to use the third-party services on our platform. Usually our partners fall into the following categories:',
        title40: '4.1.1 Service providers that provide functional support for our products/services: such as payment institutions that provide payment services (Alipay, WeChat, public account transfers), and verification institutions that provide real-name authentication functions.',
        title41: '4.1.2 Information promotion and advertising partners: You confirm that we have the right to share our use of your relevant information with information promotion and advertising partners to form indirect user portraits, de-identification or anonymization. Analytical/statistical information and de-identified user device identification codes to help them make advertising or decision-making recommendations, improve the effective reach rate of advertising, and further understand user needs.',
        title42: '4.2 Transfer',
        title43: 'We will not transfer your personal information to any company, organization or individual except with your express consent. As our business continues to develop, we may conduct spin-offs, mergers, acquisitions, asset transfers or similar transactions, and your information may be transferred as part of such transactions. We will inform you of the name of the recipient and require the recipient to continue to be bound by this Privacy Policy. If the recipient changes the purpose and method of processing personal information agreed in this privacy policy, we will require the recipient to obtain your authorization and consent again.',
        title44: '4.3 Information disclosure',
        title45: 'Except for public disclosure in compliance with laws and regulations or under the following circumstances, we will not publicly disclose your personal information that has not been disclosed by yourself or otherwise has not been legally disclosed. The following exceptions apply.',
        title46: '4.3.1 Disclose to third parties with your prior consent.',
        title47: '4.3.2 If you are a qualified intellectual property complainant and have filed a complaint, you shall disclose it to the respondent at the request of the respondent so that both parties can handle possible rights disputes.',
        title48: '4.3.3 Disclose to third parties or administrative or judicial authorities in accordance with the relevant provisions of the law or the requirements of administrative or judicial authorities.',
        title49: '4.3.4 If you violate relevant Chinese laws and regulations or the proxylink service agreement or related rules, you need to disclose it to a third party.',
        title50: '4.3.5 In order to provide the products and services you request, your personal information must be shared with third parties.',
        title51: '4.3.6 In a transaction on proxylink, if any party to the transaction fulfills or partially fulfills the transaction obligations and makes a request for information disclosure, proxylink has the right to decide to provide the user with the contact information of the counterparty and other necessary information to facilitate the transaction. completion or dispute resolution.',
        title52: '4.3.7 Other disclosures that proxylink deems appropriate in accordance with laws, regulations or website policies.',
        title53: '4.4. Exceptions to sharing, transferring, and publicly disclosing your personal information',
        title54: 'In accordance with relevant laws and other regulations, we may share, transfer, or publicly disclose your information without your consent in the following circumstances:',
        title56: '4.4.1 Necessary to provide the corresponding functions or services in "II. The information we collect" and necessary for the purposes described in the section "III. How we use the information we collect".',
        title57: '4.4.2 Perform our obligations and exercise our rights in the "Proxylink User Service Agreement" or this Agreement.',
        title58: '4.4.3 Necessary to perform legal duties or obligations, such as those directly related to national security, national defense security, criminal investigation, prosecution, trial and judgment execution, etc.',
        title59: '4.4.4 In order to respond to public health emergencies, or necessary to protect the life, health and property safety of natural persons in emergency situations.',
        title60: '4.4.5 Conduct news reporting, public opinion supervision and other activities for the public interest, and process personal information within a reasonable scope.',
        title61: '4.4.6 Personal information disclosed by users to the public.',
        title62: '4.4.7 Collect personal information from legally publicly disclosed information, such as legal news reports, government information disclosure and other channels.',
        title63: '5. How we use cookies and related technologies',
        title64: 'When you use our products/services, we may use cookies and similar technologies to collect some of your personal information, such as your website access habits, browsing information, login information, etc. The specific purposes for which we use cookies include:',
        title65: '5.1 Remember who you are. For example: Cookies help us identify you as our registered user, eliminating the need to repeatedly enter your account number in order to use our services.',
        title66: '5.2 Analyze your use of our services, understand the specific purposes for which you use our services, and which web pages or services are most popular with you, so as to provide you with more thoughtful and personalized services.',
        title67: '5.3 You can refuse or manage Cookies through your browser settings. However, please note that if you disable Cookies, you may not be able to use our related products/services normally or obtain the best service experience through our products/services, and the availability of certain functions may be affected.',
        title68: '5.4 This agreement will also apply to relevant information recorded through proxylink Cookie.',
        title69: '6. Information storage location and period',
        title70: '6.1 We will take reasonable and feasible measures to avoid collecting irrelevant user information. We will only retain your user information for the period necessary to achieve the purposes stated in this policy, unless permitted by law. After the above user information retention period expires, we will delete or anonymize your personal information.',
        title71: 'However, we may need to retain your information or part of it for a longer period of time under the following circumstances:',
        title72: '6.1.1 We should store it for a long time in accordance with laws, regulations and other relevant regulations.',
        title73: '6.1.2 We are required to store the effective judgments, rulings or other legal procedures of the court for a long time',
        title74: '6.1.3 The administrative, judicial or other competent authorities require us to preserve it for a long time.',
        title75: '6.1.4 It is necessary to execute relevant service agreements or this privacy agreement, handle complaints/disputes, or protect social interests, the personal and property safety of others, or other legitimate rights and interests.',
        title76: '7. Information security',
        title77: '7.1 In order to prevent the loss, improper use, unauthorized reading or disclosure of information, we will strive to use the following security technologies and measures to protect your user information:',
        title78: '7.1.1 We take various reasonable physical, electronic and managerial security measures to protect your user information. Protect user information from unauthorized access, public disclosure, use, modification, damage or loss.',
        title79: '7.1.2 We have established strict management systems and processes to ensure information security. For example, we strictly limit the scope of personnel who can access information. Only authorized personnel can access user information, and require relevant personnel to abide by confidentiality obligations.',
        title80: '7.1.3 If a user information security incident (leakage, loss, etc.) unfortunately occurs, we will promptly inform you by sending emails, push notifications, announcements, etc.: the basic situation and possible impact of the security incident, the measures we have taken or will take Disposal measures taken, suggestions for you to prevent and reduce risks on your own, remedial measures for you, etc. At the same time, we will also report the handling of user information security incidents in accordance with the requirements of regulatory authorities.',
        title81: "7.2 In order to better protect your information security, we recommend that you strengthen your self-protection awareness and measures. Please keep your information properly to avoid leakage. We will only be liable to the extent that your information is leaked directly due to proxylink's fault.",
        title82: '8. How do you manage your own information?',
        title83: 'During your use of our services, you can access and modify your user information. We will collect, use and store your information in accordance with legal and regulatory requirements or as agreed by both parties.',
        title84: '9. Changes to the Agreement',
        title85: '9.1 Due to policy changes, business adjustments, changes in technology and services, etc., we reserve the right to revise the terms of this Agreement, and such revisions form part of this Agreement. We will notify you by publishing on our official website before the updated Privacy Agreement takes effect. Your continued use of our services after notification shall constitute your agreement to accept the revised content. We will not reduce your rights under this Agreement unless you expressly agree. If the aforementioned revisions may result in a substantial reduction or significant change in your rights under this Agreement, we will seek your express consent again.',
        title86: '9.2 Major changes include but are not limited to:',
        title87: '9.2.1 Our service model undergoes significant changes. Such as the purpose of processing personal information, types of personal information processed, how personal information is used, etc.',
        title88: '9.2.2 We undergo major changes in ownership structure, organizational structure, etc. Such as changes in owners caused by business adjustments, bankruptcy mergers, etc.',
        title89: '9.2.3 The main objects of personal information sharing, transfer or public disclosure change.',
        title90: '9.2.4 There are significant changes in your rights to participate in the processing of personal information and how you exercise them.',
        title91: '9.2.5 Our responsible department, contact information and complaint channels for handling personal information security have changed;',
        title92: '9.2.6 When the personal information security impact assessment report indicates that there is a high risk.',
        title93: '10. Contact us',
        title94: 'If you have any questions about this Agreement or other related matters, you can send the questions to our corporate email: super@proxylink.net. We will review the issues involved as soon as possible and respond within 15 working days or within the time limit specified by laws and regulations. reply.'
      },
      privacyDataZh:{
        title1: 'proxylink隐私协议',
        title2: '协议最新更新时间：2023年07月15日',
        title3: '协议生效日期： 2023年07月15日',
        title55: '特别提示',
        title4: '感谢您选择和使用proxylink服务。',
        title5: '出于方便您注册、登录并使用proxylink相关服务的目的，我们将可能会采集、保存、使用、共享您的信息。proxylink非常重视对您的信息保护，我们将根据法律法规要求，采取对应的安全保护措施。我们将通过本《proxylink隐私协议》（以下简称“本协议”）来向您解释与说明，在您使用proxylink提供的产品、服务时，我们如何收集、使用、保管和共享您的信息，以及我们为您提供的访问、更新、控制和保护这些信息的方法。',
        title6: '除proxylink另有说明或与您另有约定外，本隐私协议中的术语涵义《proxylink用户服务协议》中所用术语相同。',
        title7: '请您仔细阅读本协议。在您以在线勾选等任何方式确认接受本协议时或您使用proxylink服务的，即视为您已充分阅读、理解并同意接受本协议的约束，本协议即在您与proxylink之间发生法律效力。',
        title8: '一、本协议的适用范围',
        title9: '1.1 本协议仅适用于proxylink（以下或称“我们”或“proxylink”）提供的产品和服务功能（以下简称“服务”）',
        title10: '1.2 本协议同样适用于因proxylink基于产品发展进行升级更新的服务和功能，包括但不限于网站、接口、定制程序以及随技术发展出现衍生产品和服务',
        title11: '1.3 本协议适用于您注册、使用proxylink时所提交的所有信息、资料，以及proxylink为了向您提供服务而收集的信息。',
        title12: '1.4 本协议不适用于其他第三方提供的产品/服务，比如您通过proxylink网站获取、使用第三方提供的产品/服务，上述您与第三方建立的法律关系所需确认的服务协议、使用政策以及其他信息，需您与服务商另行确定。',
        title13: '1.5 若我们提供的某项产品/服务有单独的隐私政策（包括其对应的各类协议中存在的特别约定），则该产品/服务的隐私政策及特殊约定将优先适用，该产品/服务隐私政策未约定或约定不明且不存在特别约定的，则以本协议内容为准。',
        title14: '二、我们收集的信息',
        title15: '2.1 您知晓并同意，我们将会通过以下几种方式收集您的信息：',
        title16: '2.1.1 在注册proxylink账号时，您主动提交的手机号码信息、实名信息，设置、确认登录密码等。',
        title17: '2.1.2 在特殊情况下，您委托并授权我们的员工或者合作伙伴代您上传、提交的相关信息，例如您委托我们的客服人员填写、上传的您的相应信息。',
        title18: '2.1.3 您使用我们的服务过程中，我们主动收集的信息，包括但不限于：',
        title19: '（1） 操作记录，我们会接收并记录您使用proxylink服务的操作记录、日志记录及相关信息等。',
        title20: '（2）合同信息，如果您需要线下交付等，您应提供联系人、联系方式、地址、开票信息、订单等必要信息。',
        title21: '2.2在您进行实名认证时，您需要根据网页提示提供姓名、身份证、手机号、人脸信息等信息。您的账户只有在通过这些认证和验证之后，才能获得使用相关产品/服务的资格，请确认提交合法、真实、有效的信息。',
        title22: '2.3若您是通过企业名义注册proxylink，则在进行实名认证时，您需向我们提交您的企业名称、统一社会信用代码、营业执照扫描件或照片、银行账号信息（包括开户行、银行账号和开户人），以及对公转账截图，我们将根据您提交的信息验证身份。',
        title23: '2.4 如果您需要加入推广计划或成为proxylink代理商，需另行签署相关协议，为履行合同所必需，您应提供联系人、联系方式等必要信息。',
        title24: '2.5 您通过我们的客服或参加我们举办的活动时，所签署的合同等材料信息。',
        title25: '2.6 其他信息，例如咨询沟通记录。',
        title26: '随着业务的发展，我们提供的产品功能和服务可能会有所调整和变化，若处理目的因此发生变更，我们将再次向您进行说明，并征得您的同意。以上信息我们至少保留6个月以上，所有操作记录均做完整日志记录，6个月后做永久封存。',
        title27: '三、我们如何使用收集的信息',
        title28: '为了向您提供优质、便捷、安全的服务，我们将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。',
        title29: '3.1 向您提供服务。',
        title30: '3.2 实现本协议“我们收集的信息”约定的目的。',
        title31: '3.3 向您推送产品消息、proxylink动态等相关业务消息和商业广告。例如，腾proxylink可以通过您的手机号码、电子邮箱等联系方式以短信、电话、电子邮件等任何方式向您推送商业广告，宣传、推广proxylink服务。',
        title32: '3.4 邀请您参与有关我们产品和服务的调查。',
        title33: '3.5 完善、优化和提高proxylink在线服务。',
        title34: '3.6 根据法律法规或监管要求向相关部门进行报告。',
        title35: '四、我们共享、转移以及公开披露的信息',
        title36: '我们仅在您明确授权/同意的前提下，遵守相关法律法规，在合法、正当、必要的范围内共享、转让、公开披露、委托处理您的信息。',
        title37: '4.1 共享',
        title38: '为了向您提供更完善、优质的产品/服务，我们可能将您的信息与我们的第三方合作伙伴共享。此时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理您的个人信息。除法律法规规定以及proxylink与您另有约定外，未经您同意，我们不会与任何无关第三方共享您的信息。',
        title39: '如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方服务。通常我们的合作伙伴有如下几类：',
        title40: '4.1.1 为我们的产品/服务提供功能支持的服务提供商：例如提供支付服务的支付机构（支付宝、微信、公户转账）、提供实名认证功能的验证机构。',
        title41: '4.1.2 信息推广和广告投放的合作伙伴：您确认我们有权与信息推广和广告投放的合作伙伴共享我们使用您的相关信息，集合形成的间接用户画像、去标识化或匿名化处理后的分析/统计类信息以及去标识化的用户设备识别码，以帮助其进行广告或决策建议、提高广告有效触达率、进一步了解用户需求。',
        title42: '4.2 转让',
        title43: '除获取您的明示同意外，我们不会将您的个人信息转让给任何公司、组织或个人。随着我们业务的持续发展，我们有可能进行分立、合并、收购、资产转让或类似的交易，您的信息有可能作为此类交易的一部分而被转移。我们会向您告知接收方的名称或者姓名，并要求接收方继续受本隐私政策的约束。如接收方变更本隐私政策中约定的个人信息处理目的、处理方式，我们将要求接收方重新获取您的授权同意。',
        title44: '4.3 信息披露',
        title45: '除符合法律法规的规定进行公开披露或以下情形外，我们不会公开披露您未自行公开或者其他未合法公开的个人信息。以下情形除外。',
        title46: '4.3.1 经您事先同意，向第三方披露。',
        title47: '4.3.2 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。',
        title48: '4.3.3 根据法律的有关规定，或者行政或司法机关的要求，向第三方或者行政、司法机关披露。',
        title49: '4.3.4如您出现违反中国有关法律、法规或者proxylink服务协议或相关规则的情况，需要向第三方披露。',
        title50: '4.3.5为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。',
        title51: '4.3.6 在proxylink的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，proxylink有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。',
        title52: '4.3.7 其它proxylink根据法律、法规或者网站政策认为合适的披露。',
        title53: '4.4.共享、转让、公开披露您的个人信息的例外',
        title54: '根据相关法律等规定，在以下情形中，我们可以不经您同意而共享、转让、公开披露您的信息：',
        title56: '4.4.1 提供“二、我们收集的信息”中的相应功能或服务所必需，以及出于“三、我们如何使用收集的信息”中的部分所述目的所必需。',
        title57: '4.4.2 履行我们在《proxylink用户服务协议》或本协议中的义务、行使我们的权利。',
        title58: '4.4.3 为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务。',
        title59: '4.4.4 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需。',
        title60: '4.4.5 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息。',
        title61: '4.4.6 用户自行向社会公众公开的个人信息。',
        title62: '4.4.7 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。',
        title63: '五、我们如何使用 Cookie 及相关技术',
        title64: '在您使用我们的产品/服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，例如您访问网站的习惯、浏览信息、登录信息等，我们使用 Cookie 的具体用途包括：',
        title65: '5.1 记住您的身份。例如：Cookie帮助我们辨认您作为我们的注册用户的身份，省去为使用我们服务而重复输入账号的步骤。',
        title66: '5.2 分析您使用我们服务的情况，了解您使用我们服务的具体用途、哪些网页或服务最受您的欢迎，以便为您提供更加周到的个性化服务。',
        title67: '5.3 您可以通过浏览器设置拒绝或管理 Cookie。但请注意，如果停用 Cookie，您有可能将无法正常使用我们的相关产品/服务或无法通过我们的产品/服务获得最佳的服务体验，某些功能的可用性可能会受到影响。',
        title68: '5.4本协议将同样适用于通过proxylink Cookie 记录的有关信息。',
        title69: '六、信息存储地点和期限',
        title70: '6.1我们会采取合理可行的措施，避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。',
        title71: '但在下列情况下，我们有可能需要较长时间保留您的信息或部分信息：',
        title72: '6.1.1 根据法律法规等有关规定我们应该长期保存。',
        title73: '6.1.2 法院生效判决、裁定或其他法律程序的要求我们长期保存',
        title74: '6.1.3 行政、司法机关或其他有权机关要求我们长期保存。',
        title75: '6.1.4 为执行相关服务协议或本隐私协议、处理投诉/纠纷，或者是保护社会利益以及他人的人身和财产安全或其他合法权益所必需的。',
        title76: '七、信息安全',
        title77: '7.1 为防止防信息的丢失、不当使用、未经授权阅览或披露，我们将努力使用以下安全技术及措施以保障您的用户信息：',
        title78: '7.1.1我们采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。',
        title79: '7.1.2 我们建立严格的管理制度和流程来确保信息的安全。例如，我们严格限制访问信息的人员范围，只有授权人员才可访问用户信息,并要求相关人员遵守保密义务。',
        title80: '7.1.3 若不幸发生用户信息安全事件（泄露、丢失等），我们会以发送电子邮件、推送通知、公告等形式及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。',
        title81: '7.2 为了更好地保护您的信息安全，我们建议您加强自我保护意识和措施。请您妥善保管自己的信息，避免泄露。我们仅在因proxylink过错直接导致您信息泄露的范围内承担责任。',
        title82: '八、您如何管理自己的信息',
        title83: '在您使用我们服务的过程中，您可以访问、修改您的用户信息。我们将依照法律法规要求或双方约定收集、使用和存储您的信息。',
        title84: '九、协议的变更',
        title85: '9.1由于政策变化、业务调整、技术和服务的变更等原因，我们保留对本协议条款进行修订的权利，该等修订构成本协议的一部分。我们将在更新后的本隐私协议生效前通过官网发布等方式通知您。通知后您继续使用我们服务对，即表示您同意接受修订后的内容。我们不会削减您按照本协议所应享有的权利，除非经过您明确同意。如果前述修订可能造成您在本协议下的权利的实质性减少或重大变更，我们会再次征求您的明示同意。',
        title86: '9.2 重大变更包括但不限于：',
        title87: '9.2.1 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。',
        title88: '9.2.2 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。',
        title89: '9.2.3个人信息共享、转让或公开披露的主要对象发生变化。',
        title90: '9.2.4 您参与个人信息处理方面的权利及其行使方式发生重大变化。',
        title91: '9.2.5 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；',
        title92: '9.2.6 个人信息安全影响评估报告表明存在高风险时。',
        title93: '十、与我们联系',
        title94: '如您对本协议或其他相关事宜有疑问，您可以将问题发送至我们的企业邮箱：super@proxylink.net，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以回复。',
      }
    }
  },
  computed: {
    t() {
      const lang = this.languageState.currentLanguage;
      return {
        home: lang === 'zh' ? '首页' : 'Home',
        services: lang === 'zh' ? '套餐' : 'Package',
        serviceDynamic: lang === 'zh' ? '动态住宅' : 'Dynamic residence',
        serviceStatic: lang === 'zh' ? '静态住宅' : 'Static residence',
        blog: lang === 'zh' ? '教程中心' : 'Tutorial Center',
        faq: lang === 'zh' ? '常见问题' : 'FAQ',
        signIn: lang === 'zh' ? '登录' : 'Sign In',
        signUp: lang === 'zh' ? '注册' : 'Sign Up',
        privacyPolicyTitle: lang === 'zh' ? '隐私政策' : 'Privacy Policy',
        privacyPolicySubtitle: lang === 'zh' ? '了解我们如何保护和使用您的个人信息' : 'Learn how we protect and use your personal information',
        // Footer translations
        contactInfo: lang === 'zh' ? '联系我们' : 'Contact Info',
        usefulLinks: lang === 'zh' ? '有用链接' : 'Useful Links',
        support: lang === 'zh' ? '支持' : 'Support',
        privacyPolicy: lang === 'zh' ? '隐私政策' : 'Privacy Policy',
        servicePolicy: lang === 'zh' ? '服务政策' : 'Service Policy',
        welcomeText: lang === 'zh' ? '欢迎尝试我们的产品！' : 'Welcome to try our products!',
        copyright: lang === 'zh' ? 'ProxyLink. © 2023 保留所有权利。' : 'ProxyLink. © 2023 All Rights Reserved.'
      };
    }
  },
  methods: {
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = null;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    handleScroll() {
      const scrollPosition = window.pageYOffset;
      this.showGoTop = scrollPosition > 300;
      this.isSticky = scrollPosition > 100;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.scrollToTop();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}
/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
</style>

<style scoped>
/* Banner Section */
.faq-banner-section {
  background-color: #F7FAFD;
  text-align: center;
}

.faq-banner-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
  position: relative;
  display: inline-block;
}

.faq-banner-section h1::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: linear-gradient(135deg, #4146E6 0%, #6a30d1 100%);
  border-radius: 2px;
  transform: translateY(5px);
}

.faq-banner-section p {
  font-size: 1.125rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* Policy Content Section */
.policy-content-section {
  background: #f8f9fa;
}

.policy-content {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.policy-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #f0f2f5;
}

.policy-header h2 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #2c3e50;
}

.policy-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 0.9rem;
  color: #666;
}

.policy-body {
  line-height: 1.8;
  color: #444;
}

.policy-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f2f5;
}

.policy-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.policy-section h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
  padding-left: 10px;
  border-left: 4px solid #007bff;
}

.policy-section h4 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #2c3e50;
  margin-top: 20px;
}

.policy-section p {
  margin-bottom: 10px;
  text-align: justify;
}

.policy-section p:last-child {
  margin-bottom: 0;
}

/* Footer */
.footer-section {
  background-color: var(--blackColor);
}

.footer-widget {
  margin-bottom: 30px;
  padding: 10px 0;
}

.footer-widget h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: var(--whiteColor);
}

.footer-widget .footer-contact-info {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .footer-contact-info li {
  opacity: 0.8;
  position: relative;
  margin-bottom: 15px;
  color: var(--whiteColor);
  padding-left: 0;
  line-height: 1.6;
}

.footer-widget .footer-contact-info li:last-child {
  margin-bottom: 0;
}

.footer-widget .footer-contact-info li a {
  color: var(--whiteColor);
  text-decoration: none;
}

.footer-widget .footer-contact-info li a:hover {
  color: var(--mainColor);
}

.footer-widget .footer-contact-info li::before {
  display: none;
}

.footer-widget .links-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.footer-widget .links-list li {
  margin-bottom: 12px;
}

.footer-widget .links-list li:last-child {
  margin-bottom: 0;
}

.footer-widget .links-list li a {
  position: relative;
  display: inline-block;
  color: var(--whiteColor);
  opacity: 0.8;
  padding: 4px;
  display: block;
}

.footer-widget .links-list li a:hover {
  opacity: 1;
  color: var(--mainColor);
}

.footer-widget .social-links {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 25px;
}

.footer-widget .social-links li {
  display: inline-block;
  margin-right: 10px;
}

.footer-widget .social-links li a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 50%;
  text-align: center;
  color: var(--blackColor);
  background-color: var(--whiteColor);
  transition: all 0.3s ease;
}

.footer-widget .social-links li a i {
  line-height: 1;
}

.footer-widget .social-links li a:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
  transform: translateY(-3px);
}

.footer-widget .social-links li:last-child {
  margin-right: 0;
}

.copyright-area {
  background-color: #3B566E;
  padding: 20px 0;
  margin-top: 40px;
}

.copyright-area p {
  color: var(--whiteColor);
  margin: 0;
  text-align: center;
}

/* Go Top Button */
.go-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 45px;
  height: 45px;
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 9999;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
}

.go-top:hover {
  background-color: #0056b3;
  transform: translateY(-3px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .faq-banner-section h1 {
    font-size: 2rem;
  }
  
  .policy-content {
    padding: 20px;
  }
  
  .policy-section h3 {
    font-size: 1.3rem;
  }
  
  .footer-widget {
    text-align: center;
  }
  
  .footer-widget .social-links {
    justify-content: center;
  }
}
</style>